<template>
  <div class="see-more-div">
    <div
      class="see-more"
      @click="$emit('click')"
    >
      查看更多 >>
    </div>
  </div>
</template>

<script>
export default {
    name: 'SeeMore',
};
</script>

<style scoped lang="scss">
.see-more-div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 15px;
    .see-more {
        cursor: pointer;
        font-size: 18px;
        color: #2873E9;
        transition: color .3s;
        &:hover {
            color: #5895f7;
        }
    }
}
</style>
